<template>
    <div class="inner">
        <div class="headline">
            <h1>{{ $t('screening.create.headline') }}</h1>
            <p>{{ getSingleProperty.address }}</p>
        </div>

        <div class="content-box small">
            <div class="container">
                <h2>{{ $t('screening.create.info.headline') }}</h2>
                <p>{{ $t('screening.create.info.text') }}</p>

                <form class="send-invite">
                    <div class="input-container">
                        <validation-provider rules="required|email" v-slot="{failed}" slim>
                            <input
                                id="email"
                                type="text"
                                v-model="email"
                                :class="{'has-error': failed}"
                                class="form-control"
                                name="email"
                                :placeholder="$t('screening.create.info.email')"
                                autofocus
                            >
                        </validation-provider>
                    </div>
                    <div class="set-deadline" @click="toggle()">
                        <simple-svg
                            :filepath="'/images/SVG/Clock.svg'"
                            :width="'20px'"
                            :height="'20px'"
                        />
                        <span>{{ $t('screening.create.info.deadline') }}</span>
                    </div>

                    <datepicker language="da" :inline="true" :mondayFirst="true" v-model="deadline" name="deadline"
                                class="datepicker" v-if="isOpen"></datepicker>


                </form>

                <button disabled v-on:click="createInvite" class="purple">
                    <span v-if="!creatingInvite">{{ $t('screening.continue.button') }}</span>
                    <span v-if="creatingInvite">{{ $t('screening.creating.button') }}</span>
                </button>
            </div>

        </div>
        <!-- <p>Number of invites {{numberOfInvites}}</p> -->
    </div>
</template>

<script>

import {store} from "../../store";
import {mapGetters} from "vuex";
import Datepicker from 'simple-vue-datepicker';
import createEntity from "../../mixins/create-entity";

export default {
    mixins: [createEntity],
    beforeRouteEnter(to, from, next) {
        if (!store.getters.getSingleProperty) {
            next('/screenings/select-property');
        }
        next();
    },
    components: {
        Datepicker
    },
    data: () => ({
        numberOfInvitations: 0,
        email: '',
        message: '',
        deadline: '',
        creatingInvite: false,
        isOpen: false
    }),
    computed: {
        ...mapGetters([
            'getSingleProperty',
            'getToken'
        ]),
        numberOfInvites: function () {
            return this.getSingleProperty.invitation_count + this.numberOfInvitations;
        },
        validateInput() {
            return this.validEmail(this.email) && this.deadline;
        },
    },
    methods: {
        toggle: function () {
            this.isOpen = !this.isOpen
        },
        validEmail(email) {
            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        async createInvite() {

                this.creatingInvite = true;
                var self = this;
                await axios({
                    method: 'POST',
                    url: window.config.apiUrl + 'api/invitation/store',
                    cancelToken: window.AuthorizationCancelSource.token,
                    data: {
                        email: this.email,
                        property_id: this.getSingleProperty.id,
                        deadline: this.deadline,
                        message: this.message
                    }
                }).then(response => {
                    self.$router.push('/screenings/' + response.data.id + '/send');
                }).finally(e => {
                    self.creatingInvite = false;
                });
                await this.$store.dispatch('fetchProperties');
                this.$store.dispatch('fetchSentInvitations', true);
                this.email = '';
                this.deadline = '';
                this.message = '';
                this.numberOfInvitations++;

        }
    }
}
</script>

<style scoped>

</style>
